import React, { useState } from 'react'

// Simple client-side password lock for a route (currently used for /pro on both the
// main and temporary sites). NOTE: this is a lightweight gate, not real security — the
// password ships in the JS bundle. It only keeps casual visitors out of the page.
const PRO_PASSWORD = 'admin@jamit'
const STORAGE_KEY = 'pro_unlocked'

const PasswordGate = ({ children }) => {
    const [unlocked, setUnlocked] = useState(() => {
        try { return sessionStorage.getItem(STORAGE_KEY) === 'true' } catch (e) { return false }
    })
    const [value, setValue] = useState('')
    const [error, setError] = useState(false)

    if (unlocked) return children

    const submit = (e) => {
        e.preventDefault()
        if (value === PRO_PASSWORD) {
            try { sessionStorage.setItem(STORAGE_KEY, 'true') } catch (e) {}
            setUnlocked(true)
        } else {
            setError(true)
        }
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#FAF7EA',
            fontFamily: 'arial',
        }}>
            <form onSubmit={submit} style={{
                background: '#FFF',
                padding: '2.5rem',
                borderRadius: '8px',
                border: '1px solid #D1D1D1',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                textAlign: 'center',
                width: '320px',
            }}>
                <h2 style={{ color: '#4F4F4F', marginTop: 0 }}>Protected page</h2>
                <p style={{ color: '#828282', fontSize: '13px' }}>Enter the password to continue.</p>
                <input
                    type="password"
                    autoFocus
                    value={value}
                    onChange={(e) => { setValue(e.target.value); setError(false) }}
                    placeholder="Password"
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '10px',
                        margin: '0.5rem 0',
                        border: `1px solid ${error ? '#E05353' : '#D1D1D1'}`,
                        borderRadius: '5px',
                        fontSize: '14px',
                    }}
                />
                {error &&
                    <p style={{ color: '#E05353', fontSize: '12px', margin: '0.25rem 0' }}>
                        Incorrect password
                    </p>
                }
                <button type="submit" style={{
                    width: '100%',
                    padding: '10px',
                    marginTop: '0.5rem',
                    background: '#FFAA0D',
                    color: '#FFF',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                }}>
                    Unlock
                </button>
            </form>
        </div>
    )
}

export default PasswordGate
